export default __webpack_public_path__ + "static/media/profil-pic-cv.b23ec1c8.jpg";